export type WorkspaceIntent = "writer" | "editor" | "both";
export function workspaceIntent(value: unknown): WorkspaceIntent | null {
  return value === "writer" || value === "editor" || value === "both" ? value : null;
}

export function workspaceHome(mode: unknown) {
  return mode === "editor" ? "/editors" : "/dashboard";
}

/** A deliberate audience choice takes precedence over a previously saved mode. */
export function workspaceHomeForIntent(intent: unknown, fallbackMode: unknown) {
  if (intent === "editor") return "/editors";
  if (intent === "writer") return "/dashboard?workspace=writer";
  return workspaceHome(fallbackMode);
}

type WorkspaceUser = {
  workspaceMode?: string;
  isGuest?: boolean;
  onboarded?: boolean;
};

/** An explicit workspace choice survives first-run gates; it never changes roles. */
export function workspaceRedirect(
  page: "dashboard" | "onboarding",
  user: WorkspaceUser | null | undefined,
  requestedWorkspace: string | null,
): string | null {
  const writerSelected = requestedWorkspace === "writer";
  if (requestedWorkspace === "editor") return "/editors";
  if (user?.workspaceMode === "editor" && !writerSelected) return "/editors";

  const writerQuery = writerSelected ? "?workspace=writer" : "";
  if (page === "dashboard" && user && !user.isGuest && user.onboarded === false) {
    return `/onboarding${writerQuery}`;
  }
  if (page === "onboarding" && (!user || user.isGuest || user.onboarded)) {
    return `/dashboard${writerQuery}`;
  }
  return null;
}
